<script>
  export let model;
  export let entry;

  let className = "";
  export { className as class };
</script>

<div
  class="border-4 border-gray-200 relative cursor-pointer {className}"
  class:border-main={entry == model}
  on:click={() => {
    model = entry;
  }}>
  {#if entry == model}

    <svg
      class="w-8 h-8 text-main absolute z-10"
      style="top:-1rem; right: -1rem"
      viewBox="0 0 72 72"
      fill="none">
      <circle cx="36" cy="36" r="36" fill="white" />
      <path
        d="M36 4C18.336 4 4 18.336 4 36C4 53.664 18.336 68 36 68C53.664 68 68
        53.664 68 36C68 18.336 53.664 4 36 4ZM29.6 52L13.6 36L18.112 31.488L29.6
        42.944L53.888 18.656L58.4 23.2L29.6 52Z"
        fill="black" />
    </svg>
  {/if}
  <slot />
</div>
